<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h1>Home</h1>
        <callout type="success">
          <p style="font-size: x-large; text-align: center;">We have implemented system updates to improve your experience. These updates will apply to applications submitted on or after February 4, 2026.</p>
          <p>Program participants now benefit from an improved application process, updated notifications, and clearer application status and outcome communications. Learn about these changes <a target="_blank" href="https://dpd-eviction-diversion-documents.s3.us-east-1.amazonaws.com/EDP+PPT+w+Audio_+LL+New+Application+Features.mp4"><u>here</u></a>.</p>
          <p>The information on this website, including the FAQ, About, and Resources tabs, has been substantially updated to reflect these changes.</p>
        </callout>
        <div>
          <p>
            Welcome to the City of Philadelphia's FREE Eviction Diversion Program (EDP). 
            The Program provides resources for landlords and tenants in residential rental properties to resolve issues while avoiding the costs of evictions and the court process. 
            <b>Under Philadelphia Code § 9-811</b>, landlord good faith participation in EDP is required before filing for an eviction. 
            Resources may include mediation, financial assistance, and/or direct negotiation support.
          </p>
        </div>
        <br>
        <div>
          <b>If you are a Landlord or Landlord Representative:</b><br><br> Please complete this EDP application carefully to participate. 
          Information shared on this application, including your contact information, may be shared with the tenant. 
          This application is available in multiple languages through the “Select Language” box at the top of this screen. 
          If you need assistance or have questions, please review the <a href="FAQ"><u>FAQ tab</u></a> or contact: <a href="mailto:EvictionDiversionProgram@coraservices.org"><u>EvictionDiversionProgram@coraservices.org</u></a>.
        </div><br>
        <!-- <div>
          As of January 2023, qualifying Eviction Diversion Program applicants may also be
          eligible to receive Targeted Financial Assistance (TFA). To be considered for
          financial assistance, the amount owed in arrears on your application must match the
          ledger or rent roll uploaded with your EDP application. Applications approved prior
          to January 26, 2023 will not be eligible for TFA.
        </div><br>
        <div>
          <b>If you are a Tenant:</b><br><br>
          Do not fill out this application. Please visit the FAQ page for information and resources
          or contact PLA’s Eviction Diversion Program Tenant Hotline at 215-523-9501.
        </div><br> -->
        <callout type="warning">
          The Notice of Diversion Rights (NOR) is available in <a :href="$norDocument" target="_blank"><u>English/Spanish</u></a>, <a :href="$norDocumentArabic" target="_blank"><u>English/Arabic</u></a>, <a :href="$norDocumentChinese" target="_blank"><u>English/Chinese (Simplified)</u></a>, <a :href="$norDocumentRussian" target="_blank"><u>English/Russian</u></a>, and <a :href="$norDocumentVietnamese" target="_blank"><u>English/Vietnamese</u></a>.
        </callout>
        <div>
          <p>
            Qualifying EDP applicants may be eligible to receive financial assistance called Targeted Financial Assistance (TFA). 
            To be considered for TFA, the amount owed in arrears on your application must be $3,500 or less and match the ledger or rent roll uploaded with your EDP application. 
          </p> 
        </div>
        <br>
        <div>
          <p>
            <b>If you are a Tenant:</b><br><br>
 
            <u>Do not</u> fill out this application - your landlord must submit the application. 
            Please visit the <a href="FAQ"><u>FAQ page</u></a> for information and resources or contact the <b>Eviction Diversion Program Tenant Hotline</b> at <a href="tel:215-523-9501"><b><u>215-523-9501</u></b></a>.
          </p>
        </div>
        <br>
        <!-- <callout type="warning">
          <b>Please note:</b> Review the FAQ tab for new information about Targeted Financial
          Assistance. Please ensure your uploaded ledger or rent roll matches the amount owed
          in arrears on your application.
        </callout> -->
        <!--<callout type="warning">
          If you are planning on applying for rental assistance or have applied, you will be automatically be added to
          the Eviction Diversion Program. You do not have to apply using this portal. For more information about Rent
          Assist, visit this site:
          <a
            href="https://phlrentassist.org/"
            target="#"
          >https://phlrentassist.org/</a>.
          <br>
          <br>
          If you have any questions, please reach out to: <a href="mailto:EvictionDiversionProgram@coraservices.org">
          EvictionDiversionProgram@coraservices.org</a>
        </callout>-->

        <!--<callout type="danger">
          The City is updating the Eviction Diversion Webportal and will begin accepting applications
          on Monday, January 10, 2022. We appreciate your patience as we transition.
        </callout>-->

        <!-- <callout type="danger">
          This EDP application is in beta testing. Please only use this webpage if you have been invited to do so. Otherwise, submit your EDP application at: <a href="https://eviction-diversion.phila.gov/">https://eviction-diversion.phila.gov/</a>.
        </callout> -->
        <router-link
          to="/LandlordApplication"
          tag="button"
          class="button is-primary"
        >
          Landlords: Apply Now
        </router-link>
        <br>
        <br>
        <!-- <callout type="info">
           <strong>For the latest COVID-19 information, visit <a href="https://phila.gov/COVID-19">phila.gov/COVID-19</a>.
            Text COVIDPHL to 888-777 to receive updates to your phone.</strong>
          <br>
          <br>
        <div>
          <h3>Contact @PHLPlanDevelop</h3>

          <li2>
            <a
              href="https://twitter.com/PHLPlanDevelop"
              target="#"
            > <i class="fab fa-twitter" /></a>
          </li2>
          <li2>
            <a
              href="https://www.facebook.com/PHLPlanDevelop/"
              target="#"
            ><i class="fab fa-facebook" /></a>
          </li2>
          <li2>
            <a
              href="https://www.instagram.com/PHLPlanDevelop/"
              target="#"
            ><i class="fab fa-instagram" /></a>
          </li2>
        </div>
        </callout> -->
      </div>
    </div>
    <br>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
<style scoped>
li2 {
  list-style-type: none;
  display: inline;
  padding-right: 25px;
}
i {
  font-size: 35px;
}

i2 {
  font-style: italic;
  font-size: 18px;
}
</style>
